class TotalSavings {
  constructor() {
    this.productGrid = document.querySelector('.order-saving-product-grid[data-total-pages]');
    this.savingsAmountEl = document.querySelector('[data-savings-amount]');
    this.savingsAmountValue = this.savingsAmountEl?.querySelector('.savings-amount-value');
    this.savingsAmountSkeleton = this.savingsAmountEl?.querySelector('.savings-amount-skeleton');

    if (!this.productGrid || !this.savingsAmountEl) return;

    this.totalPages = parseInt(this.productGrid.dataset.totalPages) || 1;
    this.ordersCount = parseInt(this.productGrid.dataset.ordersCount) || 0;
    this.ordersPerPage = parseInt(this.productGrid.dataset.ordersPerPage) || 250;
    this.maxPagesToFetch = 3;
    this.additionalSavings = 0;

    this.init();
  }

  init() {
    if (this.totalPages <= 1) return;

    const pagesToFetch = Math.min(this.totalPages - 1, this.maxPagesToFetch);

    if (pagesToFetch > 0) {
      this.loadAdditionalPages(pagesToFetch);
    }
  }

  showAmountSkeleton() {
    if (this.savingsAmountValue && this.savingsAmountSkeleton) {
      this.savingsAmountValue.style.display = 'none';
      this.savingsAmountSkeleton.style.display = 'inline-block';
    }
  }

  hideAmountSkeleton() {
    if (this.savingsAmountValue && this.savingsAmountSkeleton) {
      this.savingsAmountValue.style.display = 'inline-block';
      this.savingsAmountSkeleton.style.display = 'none';
    }
  }

  updateSavingsAmount(totalSavingsCents) {
    if (!this.savingsAmountEl || !this.savingsAmountValue) return;

    // Format as money using Shopify's formatMoney
    const formattedAmount = Shopify.formatMoney(totalSavingsCents);

    this.savingsAmountValue.textContent = formattedAmount;
    this.savingsAmountEl.setAttribute('aria-label', `Total money saved: ${formattedAmount}`);
  }

  fetchPage(pageNum) {
    return fetch(`/account?section_id=total-savings-calc&page=${pageNum}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        // Shopify section_id returns JSON with section content
        // Format: {"section-id": "<content>"}
        try {
          const jsonData = JSON.parse(responseText);
          const sectionKey = 'total-savings-calc';
          let content = '';

          if (jsonData[sectionKey]) {
            content = jsonData[sectionKey];
          } else if (jsonData[Object.keys(jsonData)[0]]) {
            // Fallback to first key if section key not found
            content = jsonData[Object.keys(jsonData)[0]];
          }

          // Extract the number from the content (it's just a number in cents)
          const savingsCents = parseFloat(content.trim()) || 0;
          return savingsCents;
        } catch (e) {
          console.error('Error parsing response for page', pageNum, ':', e);
          return 0;
        }
      })
      .catch((error) => {
        console.error('Error fetching page', pageNum, ':', error);
        return 0;
      });
  }

  loadAdditionalPages(pagesToFetch) {
    if (pagesToFetch <= 0) return;

    this.showAmountSkeleton();

    const fetchPromises = [];
    for (let i = 2; i <= Math.min(this.totalPages, this.maxPagesToFetch + 1); i++) {
      fetchPromises.push(this.fetchPage(i));
    }

    Promise.all(fetchPromises)
      .then((results) => {
        // results is an array of savings amounts in cents
        results.forEach((pageSavings) => {
          if (pageSavings > 0) {
            this.additionalSavings += pageSavings;
          }
        });

        // Calculate total savings
        const initialSavings = parseFloat(this.savingsAmountEl.dataset.initialSavings) || 0;
        const totalSavings = initialSavings + this.additionalSavings;

        // Update total savings amount
        this.updateSavingsAmount(totalSavings);
        this.hideAmountSkeleton();
      })
      .catch((error) => {
        console.error('Error loading additional pages:', error);
        this.hideAmountSkeleton();
      });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TotalSavings();
  });
} else {
  new TotalSavings();
}
